import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { MagnifyingGlass, CheckCircle, XCircle } from "@phosphor-icons/react";
import { api, errDetail } from "../lib/api";

const EX_LABELS = { bybit: "Bybit", binance: "Binance", okx: "OKX" };

export default function SymbolCheck({ exchange, symbol, marketType = "futures", disabled, disabledHint }) {
  const [result, setResult] = useState(null);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    setResult(null);
  }, [exchange, symbol, marketType]);

  const check = async () => {
    setChecking(true);
    setResult(null);
    try {
      const { data } = await api.get(`/exchanges/${exchange}/validate-symbol`,
        { params: { symbol, market_type: marketType } });
      setResult(data);
    } catch (e) {
      setResult({ error: errDetail(e) });
    } finally {
      setChecking(false);
    }
  };

  const exLabel = EX_LABELS[exchange] || exchange;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <Button type="button" data-testid="check-symbol-btn" variant="outline" size="sm"
        onClick={check} disabled={disabled || !symbol || checking}
        title={disabled ? disabledHint : undefined}>
        <MagnifyingGlass size={14} className="mr-1" /> {checking ? "Checking…" : "Check Symbol"}
      </Button>
      {result?.error && (
        <span className="text-xs text-loss flex items-center gap-1" data-testid="symbol-check-result">
          <XCircle size={14} weight="fill" /> {result.error}
        </span>
      )}
      {result && !result.error && result.valid && (
        <span className="text-xs text-profit flex items-center gap-1" data-testid="symbol-check-result">
          <CheckCircle size={14} weight="fill" /> {result.symbol} exists on {exLabel}
        </span>
      )}
      {result && !result.error && !result.valid && (
        <span className="text-xs text-loss flex items-center gap-1" data-testid="symbol-check-result">
          <XCircle size={14} weight="fill" /> {result.symbol} not found on {exLabel}
        </span>
      )}
    </div>
  );
}
